export default "__VITE_ASSET__BFPISrPu__"